import {ActionType} from "typesafe-actions";
import * as actions from "./actions";

export interface IQuestionState {
    readonly currentQuestionId: number;
    readonly progress: Record<number, IQuestionProgress>;
}

export type QuestionActions = ActionType<typeof actions>;

export interface IQuestionProgress {
    readonly levelId: number;
    readonly questionId: number;
    readonly answerId: number;
    readonly isRight: boolean;
    readonly attempts: number;
    readonly score: number;
    readonly timestamp: number;
    readonly resetTime?: number;
    readonly isTimeoutExpired?: boolean;
    readonly isSkipped?: boolean;
    readonly feedback?: Feedback;
}

export enum Feedback {
    None = 0,
    Like = 1,
    Dislike = 2
}